import { TimelineDot } from "@mui/lab";

import { keyframes } from "@mui/system";

const pulse = keyframes`
0% {
	transform: scale(1);
}

50% {
	transform: scale(1.3);
}

100% {
	transform: scale(1);
}
`;

const EtaDot = () => (
	<TimelineDot
		color="primary"
		variant="outlined"
		sx={{ margin: "auto", marginTop: "4px", animation: `${pulse} 1s infinite` }}
	/>
);

const LatestDot = () => (
	<TimelineDot
		color="primary"
		variant="filled"
		sx={{ margin: "auto", marginTop: "4px" }}
	/>
);

const Dot = () => (
	<TimelineDot
		color="grey"
		variant="filled"
		sx={{ margin: "auto", marginTop: "4px" }}
	/>
);

type TimelineEventDotProps = {
	isEta: boolean;
	latest: boolean;
};

export const TimelineEventDot = ({ isEta, latest }: TimelineEventDotProps) => {
	if (isEta) {
		return <EtaDot />;
	} else if (latest) {
		return <LatestDot />;
	} else return <Dot />;
};
